import { Icon } from "@circle-react/components/shared/Icon";
import { useAnyHoverMediaQuery } from "@circle-react/hooks/useMediaQuery";
import classNames from "classnames";

import { t } from "@/i18n-js/instance";

import { SortableLinksList } from "./SortableLinksList";
import { useLinks } from "./useLinks";

export const Links = () => {
  const { canSeeLinks, shouldShowLinks, toggleLinks, orderedList, onSort } =
    useLinks();
  const canHover = useAnyHoverMediaQuery();

  if (!canSeeLinks) {
    return null;
  }

  return (
    <div
      id="links-section"
      className="mb-8 mt-6 flex flex-col gap-1 px-3 lg:px-6"
    >
      <button
        type="button"
        className="text-c-sidebar hover:bg-c-sidebar-hover focus-visible:bg-c-sidebar-hover group flex w-full items-center space-x-px rounded-md px-4 py-1.5 text-sm font-semibold transition-colors duration-200"
        onClick={toggleLinks}
      >
        <span>{t("links")}</span>
        <div
          className={classNames("flex rounded-sm py-0.5 transition-transform", {
            "hidden group-hover:flex": canHover,
            "rotate-0": !shouldShowLinks,
            "rotate-90": shouldShowLinks,
          })}
          aria-label={
            shouldShowLinks
              ? t("community_sidebar.expand_group", { group_name: "links" })
              : t("community_sidebar.collapse_group", { group_name: "links" })
          }
        >
          <Icon type="cheveron-right" size={16} />
        </div>
      </button>
      {shouldShowLinks && (
        <SortableLinksList links={orderedList} onSort={onSort} />
      )}
    </div>
  );
};
